export default __webpack_public_path__ + "static/media/rabbit28.e25293d4.gif";